import { useSelector } from 'react-redux'
import { selectUserType } from '@/features/domain/user'
import { preview } from '@/components/form/preview'
import { useTexts } from './useTexts'
import { form } from '../../formState'

export function Name() {
  const userType = useSelector(selectUserType)
  const texts = useTexts()

  const canEditName = ['admin', 'planner', 'viewer', 'gpsonly', 'guest'].includes(userType)

  const {
    field: { value },
  } = form.useFormField('name')

  return canEditName ? (
    <form.TextField name="name" testId="name" label={texts.name} validateOn="blur change" />
  ) : (
    <preview.Field label={texts.name}>
      <preview.Value>{value}</preview.Value>
    </preview.Field>
  )
}
